var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResultSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientTransform: "matrix(.853 .521 -.521 .853 -51.688 737.214)",
    gradientUnits: "userSpaceOnUse",
    x1: -206.367,
    x2: -25.707,
    xlinkHref: "#lg1",
    y1: -649.638,
    y2: -468.978
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(.853 .521 -.521 .853 -51.688 737.214)",
    gradientUnits: "userSpaceOnUse",
    x1: -56.305,
    x2: -195.717,
    xlinkHref: "#lg1",
    y1: -570.765,
    y2: -570.765
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientTransform: "matrix(.853 .521 -.521 .853 -51.688 737.214)",
    gradientUnits: "userSpaceOnUse",
    x1: -65.48,
    x2: -370.097,
    xlinkHref: "#lg2",
    y1: -570.765,
    y2: -570.765
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientTransform: "matrix(-.853 .521 .521 .853 -2783.584 737.214)",
    gradientUnits: "userSpaceOnUse",
    x1: -3061.341,
    x2: -2880.681,
    xlinkHref: "#lg1",
    y1: 1093.912,
    y2: 1274.572
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(-.853 .521 .521 .853 -2783.584 737.214)",
    gradientUnits: "userSpaceOnUse",
    x1: -2911.279,
    x2: -3050.691,
    xlinkHref: "#lg1",
    y1: 1172.786,
    y2: 1172.786
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(-.853 .521 .521 .853 -2783.584 737.214)",
    gradientUnits: "userSpaceOnUse",
    x1: -2920.454,
    x2: -3225.071,
    xlinkHref: "#lg2",
    y1: 1172.786,
    y2: 1172.786
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 317.705,
    x2: 245.705,
    xlinkHref: "#lg2",
    y1: 128.076,
    y2: -38.591
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 340.529,
    x2: 241.196,
    xlinkHref: "#lg2",
    y1: 142.207,
    y2: -70.46
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff819c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2594,
    stopColor: "#ff7e9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4757,
    stopColor: "#fe7396"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6765,
    stopColor: "#fc628e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8668,
    stopColor: "#fa4a83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f83479"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.743,
    x2: 228.075,
    xlinkHref: "#lg3",
    y1: 78.23,
    y2: 100.768
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 204.599,
    x2: 251.216,
    xlinkHref: "#lg3",
    y1: 35.629,
    y2: 82.246
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.537,
    x2: 262.553,
    xlinkHref: "#lg2",
    y1: 65.445,
    y2: 48.46
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.044,
    x2: 245.476,
    xlinkHref: "#lg2",
    y1: 74.79,
    y2: 55.682
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(-1 0 0 1 -582.121 0)",
    gradientUnits: "userSpaceOnUse",
    x1: -880.377,
    x2: -864.046,
    xlinkHref: "#lg3",
    y1: 78.23,
    y2: 100.768
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientTransform: "matrix(-1 0 0 1 -582.121 0)",
    gradientUnits: "userSpaceOnUse",
    x1: -887.522,
    x2: -840.904,
    xlinkHref: "#lg3",
    y1: 35.629,
    y2: 82.246
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(-1 0 0 1 -582.121 0)",
    gradientUnits: "userSpaceOnUse",
    x1: -877.583,
    x2: -829.568,
    xlinkHref: "#lg2",
    y1: 65.445,
    y2: 48.46
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientTransform: "matrix(-1 0 0 1 -582.121 0)",
    gradientUnits: "userSpaceOnUse",
    x1: -858.076,
    x2: -846.644,
    xlinkHref: "#lg2",
    y1: 74.79,
    y2: 55.682
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientTransform: "matrix(.844 -.537 .537 .844 2143.328 -785.662)",
    gradientUnits: "userSpaceOnUse",
    x1: -2055.329,
    x2: -2053.669,
    xlinkHref: "#lg3",
    y1: -300.155,
    y2: -268.733
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientTransform: "matrix(1 -.014 .014 1 2403.825 -403.042)",
    gradientUnits: "userSpaceOnUse",
    x1: -2154.748,
    x2: -2127.922,
    xlinkHref: "#lg2",
    y1: 454.005,
    y2: 404.111
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00adfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f3ced"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientTransform: "matrix(1 .002 -.002 1 89.995 151.616)",
    gradientUnits: "userSpaceOnUse",
    x1: 245.708,
    x2: 274.055,
    xlinkHref: "#lg4",
    y1: 29.329,
    y2: 67.124
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientTransform: "matrix(1 .002 -.002 1 89.995 151.616)",
    gradientUnits: "userSpaceOnUse",
    x1: 16.115,
    x2: 66.44,
    xlinkHref: "#lg1",
    y1: 273.15,
    y2: 340.249
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92f37f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab272"
  }))), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientTransform: "matrix(1 .002 -.002 1 89.995 151.616)",
    gradientUnits: "userSpaceOnUse",
    x1: 143.651,
    x2: 179.236,
    xlinkHref: "#lg5",
    y1: 298.527,
    y2: 345.974
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientTransform: "matrix(1 .002 -.002 1 89.995 151.616)",
    gradientUnits: "userSpaceOnUse",
    x1: 23.996,
    x2: 47.877,
    xlinkHref: "#lg4",
    y1: 136.42,
    y2: 168.261
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b62cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3003,
    stopColor: "#985dcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6716,
    stopColor: "#8f4ec7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833ac1"
  }))), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientTransform: "matrix(1 .002 -.002 1 89.995 151.616)",
    gradientUnits: "userSpaceOnUse",
    x1: 247.34,
    x2: 284.721,
    xlinkHref: "#lg6",
    y1: 110.677,
    y2: 160.518
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.138,
    x2: 210.106,
    xlinkHref: "#lg5",
    y1: 207.836,
    y2: 174.959
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientTransform: "matrix(0 1 -1 0 -4234.693 -6987.148)",
    gradientUnits: "userSpaceOnUse",
    x1: 7448.378,
    x2: 7484.346,
    xlinkHref: "#lg3",
    y1: -4629.309,
    y2: -4662.186
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientTransform: "matrix(0 -1 -1 0 -4234.693 -589.665)",
    gradientUnits: "userSpaceOnUse",
    x1: -1032.86,
    x2: -996.892,
    xlinkHref: "#lg6",
    y1: -4528.589,
    y2: -4561.466
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.236,
    x2: 175.384,
    xlinkHref: "#lg6",
    y1: 314.069,
    y2: 341.063
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 189.271,
    x2: 169.989,
    xlinkHref: "#lg3",
    y1: 372.224,
    y2: 408.216
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.705,
    x2: 175.567,
    xlinkHref: "#lg3",
    y1: 260.783,
    y2: 293.562
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 367.326,
    x2: 400.34,
    y1: 341.284,
    y2: 438.186
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82814"
  }))), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 363.138,
    x2: 382.566,
    xlinkHref: "#lg2",
    y1: 397.694,
    y2: 400.174
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 419.575,
    x2: 405.658,
    xlinkHref: "#lg2",
    y1: 373.548,
    y2: 380.438
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientTransform: "matrix(-1 0 0 1 877.275 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 613.059,
    x2: 594.61,
    xlinkHref: "#lg3",
    y1: 281.038,
    y2: 301.076
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientTransform: "matrix(-1 0 0 1 877.275 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 603.191,
    x2: 589.153,
    xlinkHref: "#lg3",
    y1: 201.703,
    y2: 221.443
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientTransform: "matrix(-1 0 0 1 877.275 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 604.919,
    x2: 590.606,
    xlinkHref: "#lg5",
    y1: 324.208,
    y2: 350.926
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientTransform: "matrix(-1 0 0 1 877.275 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 610.901,
    x2: 592.2,
    xlinkHref: "#lg5",
    y1: 237.539,
    y2: 264.031
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m75.925 332.112c-74.719-45.631-98.299-143.194-52.668-217.913s143.194-98.299 217.913-52.667-90.527 316.212-165.245 270.58z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.925 332.112c-74.719-45.631 90.526-316.212 165.245-270.58s-90.527 316.212-165.245 270.58z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.338 83.338c-3.089-5.493-7.312-10.033-12.816-13.395-74.719-45.631-234.303 215.678-159.584 261.309 5.504 3.362 11.472 5.045 17.77 5.284 70.95-12.579 175.842-184.335 154.63-253.198z",
    fill: "url(#SVGID_3_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m434.075 332.112c74.719-45.631 98.299-143.194 52.668-217.913s-143.194-98.299-217.913-52.667 90.527 316.212 165.245 270.58z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.075 332.112c74.719-45.631-90.526-316.212-165.245-270.58s90.527 316.212 165.245 270.58z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.662 83.338c3.089-5.493 7.312-10.033 12.816-13.395 74.719-45.631 234.302 215.678 159.583 261.309-5.504 3.362-11.472 5.045-17.77 5.284-70.949-12.579-175.841-184.335-154.629-253.198z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.662 83.338c3.089-5.493 7.312-10.033 12.816-13.395 74.719-45.631 234.302 215.678 159.583 261.309-5.504 3.362-11.472 5.045-17.77 5.284-70.949-12.579-175.841-184.335-154.629-253.198z",
    fill: "url(#SVGID_7_)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m321.595 41.114c-18.173 3.479-36.042 10.205-52.765 20.417-6.678 4.078-11.43 9.961-14.51 17.247-2.664-3.479-5.905-6.457-9.799-8.836-13.891-8.484-30.717-6.352-48.424 3.025-2.688 4.249-4.038 9.365-3.547 14.695l.924 10.032c.445 4.831 3.288 8.672 7.102 10.726l49.136 49.136c2.036-6.004 3.813-11.91 5.287-17.663.247.962.501 1.929.764 2.899.026.095.052.191.078.287.848 3.114 1.779 6.267 2.789 9.454.014.044.028.089.042.133.242.761.489 1.524.739 2.289.033.099.065.198.098.298 1.043 3.168 2.161 6.365 3.351 9.585.037.099.073.198.11.297.286.771.575 1.543.869 2.316.028.075.057.15.086.225.856 2.247 1.757 4.506 2.679 6.771l160.82 160.82c2.286-.8 4.507-1.846 6.652-3.156 39.686-24.237 64.936-63.125 73.059-105.459z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m246.873 81.219c0 6.866-3.942 13.122-10.136 16.086l-23.85 11.412c-8.544 4.088-18.546-1.59-19.414-11.022l-.924-10.032c-1.068-11.599 6.517-22.232 17.832-24.998l2.336-.571c14.641-3.579 29.556 4.773 34.156 19.125z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.873 81.219v-17.769c0-11.21-4.453-21.962-12.38-29.888l-24.393-24.394c-6.322-6.322-17.14-3.019-18.852 5.757l-2.603 13.829c-3.487 18.529 7.473 36.728 25.481 42.312z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.748 54.562-17.981-13.645c-4.66-3.536-12.635-1.689-13.897 3.22l-1.918 7.735c-1.324 5.339.18 10.626 3.763 14.927 1.666 2 3.892 3.482 6.378 4.255.011.003.022.007.034.01l32.747 10.154v-9.938c-.001-6.27-3.283-12.284-9.126-16.718z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.748 64.791-1.855-.867c-7.013-3.28-15.195 1.186-16.231 8.858l27.212 8.437v-6.125c-.001-3.865-3.283-7.571-9.126-10.303z",
    fill: "url(#SVGID_12_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m263.127 81.219c0 6.866 3.942 13.122 10.136 16.086l23.85 11.412c8.544 4.088 18.546-1.59 19.414-11.022l.924-10.032c1.068-11.599-6.517-22.232-17.833-24.998l-2.336-.571c-14.64-3.579-29.555 4.773-34.155 19.125z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.127 81.219v-17.769c0-11.21 4.453-21.962 12.38-29.888l24.393-24.394c6.322-6.322 17.14-3.019 18.852 5.757l2.603 13.829c3.487 18.529-7.473 36.728-25.481 42.312z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.252 54.562 17.981-13.645c4.66-3.536 12.635-1.689 13.897 3.22l1.918 7.735c1.324 5.339-.18 10.626-3.763 14.927-1.666 2-3.892 3.482-6.378 4.255-.011.003-.022.007-.034.01l-32.747 10.154v-9.938c.001-6.27 3.283-12.284 9.126-16.718z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.252 64.791 1.855-.867c7.013-3.28 15.195 1.186 16.231 8.858l-27.212 8.437v-6.125c.001-3.865 3.283-7.571 9.126-10.303z",
    fill: "url(#SVGID_16_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m274.517 73.982c.154 10.777-8.46 19.638-19.239 19.792s-19.642-8.458-19.796-19.235 8.46-19.638 19.239-19.792c10.78-.154 19.643 8.458 19.796 19.235z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.482 56.681c1.354 2.608 2.138 5.562 2.183 8.7.154 10.777-8.46 19.638-19.239 19.792-3.138.045-6.114-.655-8.76-1.933 3.296 6.349 9.972 10.645 17.613 10.536 10.779-.154 19.393-9.015 19.239-19.792-.11-7.641-4.595-14.191-11.036-17.303z",
    fill: "url(#SVGID_18_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m369.583 195.881c-8.986 5.856-16.652 13.568-22.458 22.591-1.306 2.029-4.319 2.023-5.617-.01-5.773-9.044-13.411-16.785-22.376-22.673-1.99-1.307-1.984-4.279.01-5.579 8.986-5.856 16.652-13.568 22.458-22.591 1.306-2.029 4.319-2.023 5.617.01 5.773 9.044 13.412 16.785 22.376 22.673 1.989 1.308 1.984 4.279-.01 5.579z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.859 450.527c-15.952 10.396-29.563 24.088-39.87 40.107-2.318 3.602-7.667 3.592-9.972-.018-10.249-16.056-23.809-29.798-39.724-40.251-3.532-2.32-3.523-7.596.018-9.904 15.952-10.396 29.563-24.088 39.87-40.107 2.318-3.602 7.667-3.592 9.972.018 10.249 16.056 23.81 29.798 39.724 40.251 3.532 2.321 3.522 7.596-.018 9.904z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.705 468.597c-11.28 7.351-20.904 17.033-28.193 28.36-1.639 2.547-5.422 2.54-7.051-.013-7.247-11.353-16.836-21.07-28.089-28.462-2.498-1.641-2.491-5.372.013-7.003 11.28-7.351 20.904-17.033 28.192-28.36 1.639-2.547 5.422-2.54 7.051.013 7.247 11.353 16.837 21.071 28.09 28.462 2.498 1.641 2.491 5.372-.013 7.003z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.332 300.29c-7.57 4.933-14.029 11.431-18.92 19.032-1.1 1.709-3.638 1.705-4.732-.009-4.863-7.619-11.298-14.14-18.85-19.101-1.676-1.101-1.672-3.605.009-4.7 7.57-4.933 14.029-11.431 18.92-19.032 1.1-1.709 3.638-1.705 4.732.009 4.864 7.619 11.299 14.14 18.851 19.101 1.675 1.101 1.67 3.605-.01 4.7z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m381.882 281.852c-11.849 7.722-21.959 17.892-29.615 29.791-1.722 2.676-5.695 2.668-7.407-.014-7.613-11.926-17.685-22.133-29.506-29.898-2.624-1.724-2.617-5.643.013-7.356 11.849-7.722 21.959-17.892 29.615-29.791 1.722-2.676 5.695-2.668 7.407.013 7.613 11.926 17.686 22.133 29.507 29.898 2.623 1.724 2.616 5.643-.014 7.357z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.697 174.767v20.186c0 3.607 2.254 6.797 5.618 8.097 9.875 3.818 17.776 11.624 21.723 21.435 1.327 3.299 4.49 5.487 8.046 5.487h20.266c5.669 0 9.852-5.376 8.366-10.848-6.991-25.732-27.413-45.988-53.24-52.742-5.456-1.426-10.779 2.745-10.779 8.385z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m427.685 439.789h-20.186c-3.607 0-6.797 2.254-8.097 5.618-3.818 9.875-11.624 17.776-21.435 21.723-3.299 1.327-5.487 4.49-5.487 8.046v20.266c0 5.669 5.376 9.852 10.847 8.366 25.732-6.991 45.988-27.413 52.742-53.24 1.427-5.456-2.744-10.779-8.384-10.779z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.965 464.635h-20.186c-3.607 0-6.797-2.254-8.097-5.618-3.818-9.875-11.624-17.776-21.435-21.723-3.299-1.327-5.487-4.49-5.487-8.046v-20.266c0-5.669 5.376-9.852 10.848-8.366 25.732 6.991 45.988 27.413 52.742 53.24 1.426 5.456-2.745 10.779-8.385 10.779z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m212.692 345.164-35.743 17.277c-12.879 6.225-27.836-3.157-27.836-17.462v-15.412c0-6.145 3.515-11.749 9.048-14.424l35.743-17.277c12.879-6.225 27.836 3.157 27.836 17.462v15.412c.001 6.146-3.515 11.75-9.048 14.424z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m215.051 431.779-45.479-29.181c-12.749-8.18-20.458-22.287-20.458-37.435v-35.596c0 5.325 2.71 10.285 7.192 13.161l44.976 28.859c12.749 8.18 20.458 22.287 20.458 37.435v19.102c.001 3.434-3.798 5.51-6.689 3.655z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.804 227.354 45.479 29.181c12.749 8.18 20.458 22.287 20.458 37.435v35.596c0-5.325-2.71-10.285-7.192-13.16l-44.976-28.859c-12.749-8.18-20.458-22.287-20.458-37.435v-19.102c-.001-3.435 3.798-5.511 6.689-3.656z",
    fill: "url(#SVGID_29_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m404.415 366.06c-3.199-11.566-11.731-20.933-22.992-25.191-4.324-1.629-8.838-2.439-13.335-2.439-7.581 0-15.104 2.29-21.503 6.738-8.854 6.151-14.658 15.815-15.931 26.513-.604 5.093-.157 10.202 1.257 15.022.116.413.248.819.38 1.224.132.397.273.802.413 1.199.579 1.596 1.273 3.15 2.083 4.663.389.752.818 1.496 1.273 2.224.223.364.455.719.686 1.075l.008.008c.231.339.463.67.694 1 .099.132.19.264.289.397.43.587.876 1.149 1.339 1.711.273.331.554.661.843.984l.819.926c8.507 9.574 20.916 13.972 32.962 12.69-.653 1.314-1.364 2.604-2.125 3.869-.719 1.199-.38 2.745.785 3.514l18.635 12.31c1.224.802 2.877.446 3.646-.802 6.779-11.004 10.93-23.355 12.277-36.038l14.06-9.598c1.782-1.216 2.847-3.234 2.847-5.391v-24.551c0-2.254-2.525-3.588-4.386-2.317zm-43.123 17.766-.752-.843-.066-.074c-2.646-2.984-2.703-6.275-2.505-7.978.207-1.695 1.033-4.886 4.307-7.168 3.977-2.753 7.904-1.728 9.417-1.157 1.505.57 5.142 2.397 6.291 7.102l.24.984c.678 2.745 1.141 5.514 1.414 8.292l-3.861 2.629c-4.572 3.124-10.798 2.355-14.485-1.787z",
    fill: "url(#SVGID_30_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m339.918 401.19.82.922c8.511 9.572 20.917 13.976 32.965 12.692 8.481-12.176 5.931-31.824 5.931-31.824l-3.857 2.633c-4.574 3.124-10.801 2.357-14.484-1.784l-.755-.849h-29.511c1.24 6.7 4.273 13.017 8.891 18.21z",
    fill: "url(#SVGID_31_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.827 358.118v24.551c0 2.157-1.066 4.175-2.847 5.391l-14.06 9.598s1.844-15.187-2.505-31.598l15.025-10.258c1.862-1.271 4.387.062 4.387 2.316z",
    fill: "url(#SVGID_32_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m254.969 304.121 26.533 12.825c9.561 4.621 20.663-2.344 20.663-12.963v-11.441c0-4.562-2.61-8.722-6.717-10.707l-26.533-12.825c-9.561-4.621-20.663 2.344-20.663 12.963v11.441c0 4.562 2.61 8.721 6.717 10.707z",
    fill: "url(#SVGID_33_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.396 226.847 10.106 4.885c9.561 4.621 20.663-2.344 20.663-12.963v-11.441c0-4.562-2.61-8.722-6.717-10.707l-42.404-20.497c-2.217-1.072-4.793.544-4.793 3.007v10.823c.001 15.719 8.993 30.052 23.145 36.893z",
    fill: "url(#SVGID_34_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m253.218 368.418 33.761-21.663c9.464-6.073 15.187-16.544 15.187-27.789v-26.424c0 3.953-2.012 7.635-5.339 9.77l-33.387 21.423c-9.464 6.073-15.187 16.544-15.187 27.789v14.18c-.001 2.55 2.819 4.091 4.965 2.714z",
    fill: "url(#SVGID_35_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.439 238.52 33.387-21.423c3.327-2.135 5.339-5.816 5.339-9.769v12.292 14.133.048c0 11.245-5.723 21.717-15.187 27.789l-33.387 21.423c-3.327 2.135-5.339 5.816-5.339 9.77v-12.293-14.133-.048c0-11.244 5.723-21.716 15.187-27.789z",
    fill: "url(#SVGID_36_)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultSuccess);
export default __webpack_public_path__ + "static/media/result-success.7870496e7ac2417a9b106b96865ab49a.svg";
export { ForwardRef as ReactComponent };